import BaseEchart from './src/BaseEchart.vue'
import GraphEchart from './src/GraphEchart.vue'
import LineEchart from './src/LineEchart.vue'
import TreeEchart from './src/TreeEchart.vue'
import TreePlan from './src/TreePlan/index.vue'
import Mind from './src/TreePlan/mind.vue'
export { BaseEchart, GraphEchart, LineEchart, Mind, TreeEchart, TreePlan }

